<!-- <div class="icon"> <i class="pi pi-exclamation-circle"></i></div>
 -->
<div class="container">
    <div class="icon">
      <i class="pi pi-exclamation-circle" style="font-size: 40px; margin-top: 5px; margin-bottom: 10px;"></i>
    </div>
    <p>No Authorization</p>
    <button type="button" (click)="logout()">Logout</button>
</div>